<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
<!--      <a-form-model-item prop="parentId" >
        <span slot="label" >
          <a-tooltip>
            上级<template slot="title">上级</template>
          </a-tooltip>
        </span>
        <a-tree-select v-model="form.parentId" style="width: 100%" :disabled="formType===2"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="propertyOptions" placeholder="请选择上级"
        :replaceFields="{ children: 'children', title: 'name', key: 'id', value: 'id' }"
        tree-default-expand-all>
        </a-tree-select>
      </a-form-model-item>-->
<!--      <a-form-model-item prop="inputType" >
        <span slot="label" >
          <a-tooltip>
            {{$t('输入类型')}}<template slot="title">控制子属性的类型</template>
          </a-tooltip>
        </span>
        <a-select :placeholder="$t('请选择')+$t('输入类型')" style="width: 100%" v-model="form.inputType" @change="updateRules" allowClear>
          <a-select-option v-for="(item, index) in this.customDict.GoodsInputTypeEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>-->
      <a-form-model-item prop="name" >
        <span slot="label" >
          <a-tooltip>
            {{$t('名称')}}<template slot="title">{{$t('属性名称')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.name" :maxLength="255" :placeholder="$t('请输入')+$t('属性名称')" />
      </a-form-model-item>
      <a-form-model-item prop="insureLimit"  v-if="form.parentId!=='0' || form.type !==3">
        <span slot="label" >
          <a-tooltip>
            {{$t('保额')}}<template slot="title">{{$t('保额')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.insureLimit" :min="0" :max="999999999" :step="0.01" style="width: 100%" :placeholder="$t('请输入')+$t('保额')" />
      </a-form-model-item>
      <a-form-model-item prop="insurePrice"  v-if="form.parentId!=='0'|| form.type !==3" >
        <span slot="label" >
          <a-tooltip>
            {{$t('保费')}}<template slot="title">{{$t('保费')}}</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.insurePrice" :min="0" :max="999999999" :step="0.01" style="width: 100%" :placeholder="$t('请输入')+$t('保额')" />
      </a-form-model-item>
<!--      <a-form-model-item prop="unit" >
        <span slot="label" >
          <a-tooltip>
            {{$t('属性单位')}}<template slot="title">{{$t('属性单位')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.unit" :maxLength="32" :placeholder="$t('请输入')+$t('属性单位')" />
      </a-form-model-item>
      <a-form-model-item prop="tips" >
        <span slot="label" >
          <a-tooltip>
            {{$t('提示')}}<template slot="title">{{$t('提示')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.tips" :maxLength="255" :placeholder="$t('请输入')+$t('提示')" />
      </a-form-model-item>
      <a-form-model-item prop="picture" >
        <span slot="label" >
          <a-tooltip>
            {{$t('示例图')}}<template slot="title">{{$t('示例图')}}</template>
          </a-tooltip>
        </span>
        <oss-upload-single v-model="form.picture" prefix="goods" type="img"/>
      </a-form-model-item>-->
      <a-form-model-item prop="isDefaultSelect" >
        <span slot="label" >
          <a-tooltip>
            {{$t('是否默认选择')}}<template slot="title">{{$t('是否默认选择')}}</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.isDefaultSelect" :disabled="form.type!==3" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="isRequire" >
        <span slot="label" >
          <a-tooltip>
            {{$t('是否必选')}}<template slot="title">{{$t('是否必选')}}</template>
          </a-tooltip>
        </span>
        <a-radio-group v-model="form.isRequire" :disabled="form.type!==3" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('备注')}}<template slot="title">{{$t('备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getGoodsProperty, addGoodsProperty,listGoodsProperty, updateGoodsProperty } from '@/api/goods/goodsProperty'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    OssUploadSingle
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      requireDisable: false,
      propertyOptions:[],
      isCanAddChild: true,
      inputTypeDisable: false,
      // 表单参数
      form: {
        id: null,
        parentId: null,
        goodsId: null,
        name: null,
        type: 3,
        inputType: 'radio',
        insureLimit: 0,
        insurePrice :0,
        unit: null,
        tips: null,
        isDefaultSelect: false,
        isRequire: true,
        picture: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        parentId: [
          { required: true, message: '上级不能为空', trigger: 'change' }
        ],
        goodsId: [
          { required: true, message: this.$t('商品id')+this.$t('不能为空'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('属性名称')+this.$t('不能为空'), trigger: 'blur' }
        ],

        inputType: [
          { required: true, message: this.$t('输入类型')+this.$t('不能为空'), trigger: 'change' }
        ],
        isDefaultSelect: [
          { required: true, message: this.$t('是否默认选择')+this.$t('不能为空'), trigger: 'change' }
        ],
        isRequire: [
          { required: true, message: this.$t('是否必选')+this.$t('不能为空'), trigger: 'change' }
        ],
        insureLimit: [
          { required: true, message: this.$t('保额')+this.$t('不能为空'), trigger: 'blur' }
        ],
        insurePrice: [
          { required: true, message: this.$t('保费')+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        parentId: null,
        goodsId: null,
        name: null,
        type: 3,
        inputType: 'radio',
        insureLimit: 0,
        insurePrice :0,
        unit: null,
        tips: null,
        isDefaultSelect: false,
        isRequire: true,
        picture: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},
      }
    },
    getPropertyList(goodsId) {
      /*这个方法是树的写法*/
      listGoodsProperty({"goodsId":goodsId}).then(response => {
        const cate = { id: "0", name: this.$t('根节点'), children: [] }
        cate.children = this.handleTree(response.data, 'id','parentId')
        this.propertyOptions.push(cate)
      })
    },
    updateRules() {
    },
    /** 新增按钮操作 */
    handleAdd (pid,inputType,goodsId) {
      //判断商品id是否存在
      if (!goodsId) {
        this.$message.error('清先选择商品')
        return
      }
      this.getPropertyList(goodsId)

      this.reset()
      this.formType = 1
      this.open = true
      if (pid) {
        this.form.parentId = pid
      } else {
        this.form.parentId = "0"
      }
      if (inputType) {
        this.form.inputType = inputType
        this.inputTypeDisable = true
      }
      this.form.goodsId=goodsId;
      this.formTitle = this.$t('添加');
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.getPropertyList(row.goodsId)
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGoodsProperty({"id":id}).then(response => {
        this.form = response.data
        this.inputTypeDisable=true
        this.updateRules()
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateGoodsProperty(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addGoodsProperty(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
